import MuiTypography from '@mui/material/Typography';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import { Box, Chip, Stack, Tooltip, Grid } from '@mui/material';
import moment from 'moment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Fragment } from 'react';
import { green, red } from '@mui/material/colors';
import attendances from '..';
import TableCellEdit from '../../../components/table/components/TableCellEdit.component';
import { API } from '../api';
import TextField from '../../../components/form/components/TextField.component';
import * as yup from 'yup';
import { API as teams } from '../../teams/api';
import AsyncAutocompleteMultiple from '../../../components/form/components/AsyncAutocompleteMultiple.component';

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 100,
    },
    sort: {
      by: 'createdAt',
      direction: 'desc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'attributes',
      key: 'mexal_validation',
      sort_key: 'mexal_validation',
      sortable: true,
      label: 'Mexal',
      maxWidth: 70,
      width: 70,
    },
    {
      id: 'attributes.is_central_agent',
      key: 'is_central_agent',
      sort_key: 'is_central_agent',
      sortable: true,
      label: 'CA',
      width: 50,
    },
    {
      id: 'attributes.id_yacht.data.attributes.yacht_type',
      key: 'yacht_type',
      sort_key: 'id_yacht.yacht_type',
      sortable: true,
      label: 'Yacht Type',
      maxWidth: 105,
      width: 50,
    },
    {
      id: 'attributes.id_yacht.data',
      key: 'yacht_name',
      sort_key: 'id_yacht.yacht_name',
      sortable: true,
      label: 'Yacht Name',
    },
    {
      id: 'attributes.id_agent_NA.data.attributes.id_users_permissions_user.data.attributes',
      key: 'id_agent_NA',
      sort_key: 'id_agent_NA.id_users_permissions_user.name',
      sortable: true,
      label: 'NA Department',
    },
    {
      id: 'attributes.id_user_provision.data.attributes.id_users_permissions_user.data.attributes',
      key: 'sales_agent',
      sort_key: 'id_user_provision.id_users_permissions_user.name',
      sortable: true,
      label: 'SALES AGENT',
    },
    {
      id: 'attributes.teams_id',
      key: 'teams',
      sort_key: 'id_teams.name',
      sortable: true,
      label: 'Teams',
      checkbox: true,
    },
    {
      id: 'attributes.id_provenence_list.data.attributes.provenence.data.attributes.provenence',
      key: 'id_provenence_list.provenence.provenence',
      sort_key: 'id_provenence_list.provenence.provenence',
      sortable: true,
      label: 'Provenance',
    },
    {
      id: 'attributes.id_provenence_list.data.attributes.provenence_group.data.attributes.group',
      key: 'id_provenence_list.provenence_group.group',
      sort_key: 'id_provenence_list.provenence_group.group',
      sortable: true,
      label: 'Category',
    },
    {
      id: 'attributes.note_attendance_id',
      key: 'note_attendance_id',
      sort_key: 'note',
      label: 'Note',
      width: 300,
      checkbox: true,
    },
  ],
  render: {
    formatHead: (key, value) => {
      switch (key) {
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick) => {
      switch (key) {
        case 'id_agent_NA':
        case 'sales_agent':
          return (
            <Box display='flex' alignItems='center' onClick={onClick}>
              {value ? (
                <Fragment>
                  <PersonIcon color='action' fontSize='small' />
                  <MuiTypography sx={{ ml: 1 }} variant='body1'>
                    {`${value?.name} ${value?.surname}`}
                  </MuiTypography>
                </Fragment>
              ) : (
                '-'
              )}
            </Box>
          );
        case 'yacht_type':
          return (
            <MuiTypography variant='body1' sx={{ fontWeight: 'bold' }}>
              {value?.toUpperCase() || '-'}
            </MuiTypography>
          );
        case 'yacht_name':
          return (
            <Stack
              direction={'row'}
              justifyContent={'space-between'}
              spacing={1}
            >
              <MuiTypography variant='body1' sx={{ fontWeight: 'bold' }}>
                {value?.attributes?.yacht_name || ''}
              </MuiTypography>
              <Chip label={`#${value?.id || '-'}`} size='small' />
            </Stack>
          );

        case 'is_central_agent':
          return (
            <Box display='flex' alignItems='center' onClick={onClick}>
              {value ? (
                <CheckCircleIcon sx={{ color: green[500] }} />
              ) : (
                <CancelIcon sx={{ color: red[500] }} />
              )}
            </Box>
          );
        case 'mexal_validation':
          return (
            <Box
              display='flex'
              alignItems='center'
              justifyContent='center'
              width='100%'
              onClick={onClick}
            >
              {value?.mexal_validation ? (
                value?.mexal_code ? (
                  <Tooltip title={value?.mexal_research_name || ''}>
                    <Chip size='small' label={value?.mexal_code} />
                  </Tooltip>
                ) : (
                  <CheckCircleIcon sx={{ color: green[500] }} />
                )
              ) : (
                <CancelIcon sx={{ color: red[500] }} />
              )}
            </Box>
          );
        case 'registration_date':
          return (
            <Box display='flex' alignItems='center' onClick={onClick}>
              {value ? (
                <Fragment>
                  <CalendarIcon color='action' />
                  <MuiTypography sx={{ ml: 1 }} variant='body1'>
                    {moment(value).format('DD-MM-YYYY')}
                  </MuiTypography>
                </Fragment>
              ) : (
                '-'
              )}
            </Box>
          );

        case 'note_attendance_id':
          return (
            <TableCellEdit
              module={{
                ...attendances,
                query: {
                  ...attendances.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{
                note: value?.note || '',
              }}
              value={value}
              name={'note'}
              schema={yup.object({
                note: yup
                  .string()
                  .max(255, 'You can enter a maximum of 255 characters')
                  .nullable(),
              })}
              form={
                <TextField
                  id='note'
                  name='note'
                  label='Note'
                  type='text'
                  multiline
                  rows={5}
                />
              }
            >
              <MuiTypography variant='body1' textAlign={'justify'}>
                {value?.note || '-'}
              </MuiTypography>
            </TableCellEdit>
          );


        case 'teams':
          return (
            <TableCellEdit
              module={{
                ...attendances,
                query: {
                  ...attendances.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{
                id_teams: value?.id_teams?.map((item) => ({
                  id: item?.id,
                  name: item?.attributes?.name,
                })),
              }}
              value={value}
              name={'id_teams'}
              form={
                <Grid item xs={12} sm={12}>
                  <AsyncAutocompleteMultiple
                    id='id_teams'
                    name='id_teams'
                    label='Teams'
                    api={teams.select}
                  />
                </Grid>
              }
              width={300}
            >
              <Stack direction='row' flexWrap='wrap' useFlexGap gap={0.5}>
                {value?.id_teams.map((item) => (
                  <Chip key={item?.id} label={item?.attributes?.name || '-'} size='small' />
                ))}
              </Stack>
            </TableCellEdit>
          );

        default:
          return (
            <MuiTypography variant='body1' onClick={onClick}>
              {value ? value : '-'}
            </MuiTypography>
          );
      }
    },
  },
};
